import Phaser from 'phaser';
import { Sfx } from '../systems/Sfx';
import { Music } from '../systems/Music';

/**
 * Minimal first scene. Kept separate from PreloadScene so that later, when
 * real texture atlases exist, the loading-bar graphic itself can be loaded
 * here before PreloadScene shows it.
 */
export class BootScene extends Phaser.Scene {
  constructor() {
    super('Boot');
  }

  preload(): void {
    // Loaded here (not in PreloadScene) specifically so the loading screen
    // itself has art to show while everything else loads.
    this.load.svg('mascot_promo', 'assets/images/mascot_promo.svg', { width: 128, height: 128 });
  }

  create(): void {
    // The sound manager exists as soon as the game boots, independent of
    // when the audio files themselves finish loading in PreloadScene.
    Sfx.init(this.sound);
    Music.init(this.sound);
    this.scene.start('Preload');
  }
}
